export default class mainRoute {
  static route =
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
      ? 'http://localhost:8080/'
      : 'https://api.anytime-soccer.com/';
}
